export default {
  title: "Operations",
  name: "Name",
  location: "Location",
  label_name: "Name:",
  label_location: "Location:",
};
